const crop = {
  namespaced: true,
  state: {
    crop: {
      maxWidth: 200,
      maxHeight: 200,
      minWidth: 200,
      minHeight: 200,
      viewMode: 2,
      name: 0,
      aspectRatio: 1,
      minSize: true,
      infoSize: '',
    },
  },
  actions: {
    config({ commit }, data) {
      commit('initCrop', data);
    },
  },
  mutations: {
    initCrop(state, param) {
      this.state.crop = param;
      console.log(param);
      console.log(this.state);
    },
  },
};

export default crop;
